import { HOUR, MINUTE, SECOND } from "@shared/constants"

/** 이번 달 적립 한도 */
export const WOW_MONEY_MAX_PRICE = 20000

/**
 * 이번 달 한도를 채웠는지. 누적액을 아직 모르면 false.
 *
 * 판정 시점에 따라 쓰임이 갈리므로 결과를 한 값으로 공유하지 않는다.
 * - 지금 값으로 판정: 상단바 상태(WowMoneyStatus). 채우는 즉시 완료 안내로 바뀌어야 한다
 * - 입장 시점으로 고정: 적립 대상 여부(isAccrualTarget).
 *   실시간으로 뒤집히면 완료 축하 팝업이 뜨자마자 사라진다
 */
export const hasReachedMaxPrice = (cumulativePrice?: number) =>
  cumulativePrice !== undefined && cumulativePrice >= WOW_MONEY_MAX_PRICE

/** 1회 적립 금액 */
export const WOW_MONEY_UNIT_PRICE = 1000

/** 적립 주기. 주기 시작 시각으로부터 이만큼 지나면 적립한다 */
export const WOW_MONEY_INTERVAL = HOUR

/** 상단바가 기본 안내 문구와 룰렛 이벤트 문구를 번갈아 보여주는 주기 */
export const WOW_MONEY_BANNER_ROTATE_INTERVAL = 30 * MINUTE

/** 적립 안내 팝업의 종류 */
export type WowMoneyPopupType =
  | "ANONYMOUS"
  | "ENTER"
  | "ACCUMULATE"
  | "COMPLETE"

/** 상단바에 띄우는 적립 알림의 종류 */
export type WowMoneyNotificationType = "ACCUMULATE" | "COMPLETE"

/** 상단바 적립 현황이 보여줄 상태 */
export type WowMoneyStatus =
  | "ANONYMOUS"
  | "ACCRUING"
  | "COMPLETED"
  /** 방송이 끝나 더 적립되지 않는 상태 */
  | "ENDED"

export interface WowMoneyNotification {
  /** 같은 종류의 알림이 반복돼도 다시 노출되도록 하는 식별자 */
  id: number
  type: WowMoneyNotificationType
  price?: number
  /** 서버가 내려준 실패 사유. 있으면 기본 문구 대신 이걸 보여준다 */
  message?: string
}

/** 적립 안내 팝업의 자동 닫힘 시간 */
export const WOW_MONEY_POPUP_CLOSE_DELAY = 10 * SECOND

/** 알림 종류별 자동 닫힘 시간. 읽는 데 시간이 더 필요한 알림은 길게 둔다 */
export const WOW_MONEY_NOTIFICATION_CLOSE_DELAY: Record<
  WowMoneyNotificationType,
  number
> = {
  ACCUMULATE: 2 * SECOND,
  COMPLETE: 4 * SECOND,
}
